
import {Options, Vue} from 'vue-class-component';
// @ts-ignore
import MyVideo from '@/components/MyVideo.vue';
import PunchInfo from '@/components/PunchInfo.vue';

@Options({
    components: {
        PunchInfo,
        MyVideo,
    },
    created() {
        const {query} = this.$route;
        const {id = '1', isSH = 0} = query;
        this.isSH = Number(isSH);
        document.addEventListener('visibilitychange', this.stopOther, false);
        this.getPageDataApi(id);
        this.audioContext = document.getElementsByClassName('report-audio');
    },
    destroyed() {
        document.removeEventListener('visibilitychange', this.stopOther);
    },
})
export default class StudyReport extends Vue {
    isSH = 0;

    isShowPunchData = false;

    pageData:objMap = {
        achievement: {
            totalRead: '-',
            learnDays: '-',
            speechNum: '-',
        }
    };

    avatarUrl = 'https://maodou.feihua100.com/static/favicon.ico';

    waveIdx = -1;

    audioContext:any = [];

    // 获取页面数据
    getPageDataApi(id:number) {
        this.$http.get(this.$Api.studyReportSharePage2, {id})
            .then((res:any) => {
                console.log(res);
                if (res.code === '0') {
                    // window.gio('track', 'browse_study_report_share', {course: `《${res.data.courseName}》${res.data.courseTypeName}`});
                    this.pageData = res.data;
                    // 测试用
                    // this.pageData.opusVideo = "https://feihua-static.oss-cn-beijing.aliyuncs.com/ops_audio/718010011/6/audio.wav";
                    this.isShowPunchData = !!res.data.dailyAttendance;
                    this.avatarUrl = this.pageData.avatarUrl || this.avatarUrl;
                    let tagIndex = 1;
                    const {summary} = res.data;
                    if (summary) {
                        summary.forEach((item:objMap) => {
                            const {body} = item;
                            body.forEach((itm:objMap) => {
                                if (itm.property === 'Video') {
                                    itm.tagIndex = tagIndex++;
                                }
                            });
                        });
                    }
                    this.setSubtitle();
                }
            })
            .catch((error:any) => {
                console.log(error);
            });
    }

    // 同一时间只能播放一个音频
    stopOther() {
        if (this.waveIdx !== -1) {
            this.audioContext[this.waveIdx].pause();
            this.waveIdx = -1;
        }
    }

    // 播放童言童语声音
    playUserAudio(e:any) {
        const tar = e.target;
        const {idx} = tar.dataset;
        if (this.waveIdx !== -1 && this.waveIdx !== +idx) {
            this.stopOther();
        }
        if (this.$refs.myvideo) {
            this.$refs.myvideo.pauseVideo();
        }
        const oA = tar.querySelector('audio');
        try {
            if (oA.paused) {
                this.waveIdx = +idx;
                oA.volume = 1;
                oA.play();
            }
            else {
                this.waveIdx = -1;
                oA.pause();
            }
        }
        catch (err) {
            console.log('err', err);
        }
    }

    // 设置 subtitle
    setSubtitle() {
        const st = this.pageData.subtitle;
        const arr = st.split('《');
        if (arr[1] && arr[1].length > 11) {
            this.pageData.subtitle1 = arr[0].trim();
            this.pageData.subtitle2 = `《${arr[1]}`;
        }
        else {
            this.pageData.subtitle1 = this.pageData.subtitle;
        }
    }

    // 关闭打卡信息弹窗
    closePunchDialog() {
        this.isShowPunchData = false;
    }
}
